/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Social_ProofInputs */

const en_onboarding_paywall_social_proof = /** @type {(inputs: Onboarding_Paywall_Social_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8 million users have paid to upgrade their focus with Forest.
Will you be next?`)
};

const ar_onboarding_paywall_social_proof = /** @type {(inputs: Onboarding_Paywall_Social_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لقد دفع 8 ملايين مستخدم مقابل ترقية تركيزهم باستخدام Forest. 
 هل ستكون أنت التالي؟`)
};

const de_onboarding_paywall_social_proof = /** @type {(inputs: Onboarding_Paywall_Social_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8 Millionen Nutzer haben dafür bezahlt, ihren Fokus mit Forest aufzurüsten - werden Sie der Nächste sein?`)
};

const es_onboarding_paywall_social_proof = /** @type {(inputs: Onboarding_Paywall_Social_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8 millones de usuarios han pagado para mejorar su concentración con Forest.
¿Serás tú el siguiente?`)
};

const fr_onboarding_paywall_social_proof = /** @type {(inputs: Onboarding_Paywall_Social_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8 millions de personnes ont choisi de passer à Forest Plus pour améliorer leur concentration. Et vous, quand sauterez-vous le pas ?`)
};

const it_onboarding_paywall_social_proof = /** @type {(inputs: Onboarding_Paywall_Social_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8 milioni di utenti hanno pagato per migliorare la propria concentrazione con Forest. 
Sarai il prossimo?`)
};

const ja_onboarding_paywall_social_proof = /** @type {(inputs: Onboarding_Paywall_Social_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すでに800万人以上が集中力を向上させるためForest Plusに登録しています。
次はあなたの番です。`)
};

const ko_onboarding_paywall_social_proof = /** @type {(inputs: Onboarding_Paywall_Social_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest에서 지금까지 800만 명의 사용자분들이 집중력 업그레이드를 위해 유료 결제를 선택했어요.
함께 도전해 보는 것이 어떨까요?`)
};

const pt_br_onboarding_paywall_social_proof = /** @type {(inputs: Onboarding_Paywall_Social_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8 milhões de usuários pagaram para fazer um upgrade de seu foco com o Forest. Você vem também?`)
};

const ru_onboarding_paywall_social_proof = /** @type {(inputs: Onboarding_Paywall_Social_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8 миллионов пользователей оплатили улучшение своей концентрации с помощью Forest.
Присоединитесь к ним?`)
};

const th_onboarding_paywall_social_proof = /** @type {(inputs: Onboarding_Paywall_Social_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ใช้กว่า 8 ล้านคนได้จ่ายเงินเพื่ออัปเกรดการโฟกัสกับ Forest
คุณจะเป็นคนต่อไปหรือไม่?`)
};

const tr_onboarding_paywall_social_proof = /** @type {(inputs: Onboarding_Paywall_Social_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8 milyon kullanıcı Forest ile odaklarını yükseltmek için ödeme yaptı. 
Sıradaki sen misin?`)
};

const zh_cn_onboarding_paywall_social_proof = /** @type {(inputs: Onboarding_Paywall_Social_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`800 万人已付费启用 Forest，让专注再升级。
下一位会是你吗？`)
};

const zh_tw_onboarding_paywall_social_proof = /** @type {(inputs: Onboarding_Paywall_Social_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`800 萬人已付費啟用 Forest，讓專注再升級。
下一位會是你嗎？`)
};

/**
* | output |
* | --- |
* | "8 million users have paid to upgrade their focus with Forest. Will you be next?" |
*
* @param {Onboarding_Paywall_Social_ProofInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_social_proof = /** @type {((inputs?: Onboarding_Paywall_Social_ProofInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Social_ProofInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_social_proof(inputs)
	if (locale === "ar") return ar_onboarding_paywall_social_proof(inputs)
	if (locale === "de") return de_onboarding_paywall_social_proof(inputs)
	if (locale === "es") return es_onboarding_paywall_social_proof(inputs)
	if (locale === "fr") return fr_onboarding_paywall_social_proof(inputs)
	if (locale === "it") return it_onboarding_paywall_social_proof(inputs)
	if (locale === "ja") return ja_onboarding_paywall_social_proof(inputs)
	if (locale === "ko") return ko_onboarding_paywall_social_proof(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_social_proof(inputs)
	if (locale === "ru") return ru_onboarding_paywall_social_proof(inputs)
	if (locale === "th") return th_onboarding_paywall_social_proof(inputs)
	if (locale === "tr") return tr_onboarding_paywall_social_proof(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_social_proof(inputs)
	return zh_tw_onboarding_paywall_social_proof(inputs)
});